import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";

let props = {};
let inputObj = {};
let InputJSONString = "";
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;

export const getDdServiceTypeData = async () => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "F4_SERVICE_TYPE";
  inputObj["Input"] = JSON.stringify("");
  props.input = inputObj;

  let result = [
    {
      value: "all",
      text: "ALL",
    },
    ...(await GatewayGet(props, props.input)),
  ];

  result = result.map((r) => ({...r, valueText: `${r['value']} - ${r['text']}`}))
  return result;
};

export const getDdOriginDestinationData = async () => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "PRE_QUAL_DROP_DOWN_LOC_V1";
  inputObj["Input"] = JSON.stringify("");
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};


export const getServiceLevelData = async () => {
  inputObj["Activity"] = "CRM_F4_SERVICE_LEVEL";
  inputObj["Input"] = JSON.stringify("");
  props.input = inputObj;
  let _tempResult = [];

  let result = [
    {
      value: "AL",
      text: "ALL",
    },
    ...(await GatewayGet(props, props.input)),
  ];
  
  result = result.map(servicelevel => {
    if(servicelevel.value != undefined)
    _tempResult.push(({...servicelevel, valueText: `${servicelevel['value']} - ${servicelevel['text']}`}))
  })
  return _tempResult;
};

export const getQualificationCarrierTableData = async (data) => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "PRE_QUAL_SEARCH";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export const deleteQualificationFromTable = async (data) => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "PRE_QUAL_DB_OPS";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export const addQualificationRecord = async (data) => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "PRE_QUAL_DB_OPS";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};